import { getConfig } from '@caudena/core/useConfig'

export const API_ENDPOINT = `${getConfig()?.COMPLIANCE_API}/api`
export const API_PLATFORM_ENDPOINT = `${getConfig()?.PLATFORM_URL}/api`
